// extracted by mini-css-extract-plugin
module.exports = {"rootMenuIcon":"MenuIcon_rootMenuIcon__2ZST6"};